import React, { useState } from 'react'

import Button from '../Form/Button'

import * as S from './styles'

import { INITIAL_PAGE } from '../../utils/constants'

const LoadMore = ({ show, handleGetData, LIMIT }) => {
  const [page, setPage] = useState(INITIAL_PAGE)

  const handleClickLoadMore = async () => {
    const newPage = page + 1
    const skip = page * LIMIT
    const payload = { skip, limit: LIMIT }
    await handleGetData(payload)
    setPage(newPage)
  }

  return (
    <>
      { show && (
        <S.Container>
          <Button outline onClick={handleClickLoadMore}>Carregar mais</Button>
        </S.Container>
      )}
    </>
  )
}

export default LoadMore
